import React from 'react'
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import { motion } from "framer-motion";

export default function Process() {
    const steps = [
        {
            id: 1,
            title: "Requirement Analysis",           
            icon: <FileDownloadDoneIcon fontSize="large" />           
        },
        {
            id: 2,
            title: "Structuring",          
            icon: <FileDownloadDoneIcon fontSize="large" />
        },
        {
            id: 3,
            title: "Investor Mapping",
            icon: <FileDownloadDoneIcon fontSize="large" />
        },
         {
            id: 4,
            title: "Execution",
            icon: <FileDownloadDoneIcon fontSize="large" />
        },
        {
            id: 5,
            title: "Closure",
            icon: <FileDownloadDoneIcon fontSize="large" />           
        }
    ];
    return (

         <section className="w-full py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
            <h5 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-dark-gold leading-snug mb-4">Transparent Deal Execution</h5>
            <p className='pb-20 text-xl opacity-50'>Experience a seamless journey with our fully digital process. Apply in minutes, verify instantly, and receive funds directly in your account without unnecessary delays.</p>
        </div>
     
        {/* Steps */}
        <div className="relative">

          {/* Dotted Line (Desktop only) */}
          <div className="hidden md:block absolute top-10 left-0 right-0 border-t-2 border-dashed border-[#A67C00]"></div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.2,
                },
              },
            }}
            className="grid grid-cols-1 md:grid-cols-5 gap-10"
          >
            {steps.map((step, index) => (
              <motion.div
                key={step.id}
                variants={{
                  hidden: { opacity: 0, y: 50 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                className="flex flex-col items-center text-center relative group"
              >

                {/* Circle */}
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="relative"
                >
                  <div
                    className={`w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center text-white shadow-lg bg-premium-gold transition-all duration-300`}
                  >
                    {step.icon}
                  </div>

                  {/* Step Number */}
                  <div
                    className={`absolute -top-2 -right-2 w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold bg-navy `}
                  >
                    {step.id}
                  </div>
                </motion.div>

                {/* Title */}
                <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-2">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm max-w-xs">
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>

    )
}
